import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import '@desyre/design-system-web/dist/footer';
import '@desyre/design-system-web/dist/checkbox';
import rede from '@meiuca/desyre-design-assets/dist/assets/brands/rede_orange.js';
import { ConsentimentoService } from '../services/consentimento/consentimento.service';
import { AuthCedentialsService } from '../services/guards/auth-credentials.service';

@Component({
  selector: 'app-consent-form',
  imports: [CommonModule],
  templateUrl: './consent.component.html',
  styleUrls: ['./consent.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ConsentFormComponent implements OnInit {
  isDataLoaded = false;
  redeOrange = rede;
  clientId = '';
  state = '';
  tokenJwt = '';
  requestedScopes = [];
  newScopes = [];
  authorizedScopes = [];
  scopesAlias = [];
  requestUri = `${environment.backendUrl}/oauth2/authorize`;
  showForm = false;
  http: any;

  @ViewChild('formConsent') set formConsent(formConsent: ElementRef) {
    if (formConsent) {
      if (!this.scopesAreValid()) {
        let form = formConsent.nativeElement as HTMLFormElement;
        form.submit();
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    private service: ConsentimentoService,
    private readonly authCedentialsService: AuthCedentialsService,
    private readonly router: Router
  ) {}

  async ngOnInit() {
    // TODO Buscar descrições dos escopos do backend e validar sessão, caso o usuário não tenha sessão essa página não deverá ser renderizada
    this.route.queryParams.subscribe((params) => {
      this.clientId = params['client_id'];
      this.state = params['state'];
      this.tokenJwt = this.authCedentialsService.getToken();
      this.requestedScopes = params['scope'].split(' ');
    });

    let dadosBasicos = await this.service.dadosBasicos(
      this.clientId,
      this.requestedScopes.join(' '),
      this.tokenJwt
    );

    if (dadosBasicos && dadosBasicos['authenticated']) {
      this.scopesAlias = dadosBasicos['scopes'];
      this.newScopes = dadosBasicos['scopes'];
      this.isDataLoaded = true;
    } else {
      window.location.href = '/login';
    }

    this.showForm = this.scopesAreValid();

    console.log('this.showForm', this.showForm);

    if (dadosBasicos['authorizedScopes']) {
      this.authorizedScopes = dadosBasicos['authorizedScopes'];
      this.scopesAlias = this.scopesAlias.concat(this.authorizedScopes);
      this.requestedScopes = this.requestedScopes.filter(
        (el) => !this.authorizedScopes.includes(el)
      );
    }
  }

  onSubmit(event: Event): void {
    event.preventDefault();
    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);

    fetch(this.requestUri, {
      method: 'POST',
      headers: {
        Authorization: this.tokenJwt,
      },
      body: formData,
    }).then((response: any) => {
      if (response.ok) {
        const redirectUrl = response.headers.get('redirectUrl');
        window.location.href = redirectUrl;
      } else {
        this.authCedentialsService.removeToken();
        this.router.navigate(['/login'], { queryParams: { error: true } });
      }
    });
  }

  setTokenForm(formConsent: HTMLFormElement) {
    const token = this.authCedentialsService.getToken();

    fetch(this.requestUri, {
      method: 'POST',
      headers: {
        Authorization: token,
      },
      body: new FormData(formConsent),
    }).then((response) => {
      if (response.ok) {
        const redirectUrl = response.headers.get('redirectUrl');
        window.location.href = redirectUrl;
      } else {
        this.authCedentialsService.removeToken();
        this.router.navigate(['/login'], { queryParams: { error: true } });
      }
    });
  }

  public recuperarAlias(scopo: any) {
    var dadosAlias = this.scopesAlias.find((obj) => obj.code === scopo);
    return dadosAlias != null && dadosAlias.alias ? dadosAlias.alias : scopo;
  }

  public cancelConsent() {
    let formConsent = <HTMLFormElement>document.getElementById('form-consent');
    formConsent.reset();
    let inputs = document.querySelectorAll("input[type='checkbox']");
    for (let i = 0; i < inputs.length; i++) {
      let checkbox = inputs[i] as HTMLInputElement;
      checkbox.checked = false;
    }
    this.setTokenForm(formConsent);
  }

  public scopesAreValid(): boolean {
    if (this.requestedScopes && this.requestedScopes[0] == '') {
      this.router.navigate(['/login'], { queryParams: { error: true } });
      return false;
    } else if (this.requestedScopes && this.requestedScopes[0] !== '') {
      return true;
    }
  }
}
